import {DEALER_DATA_AVAILABLE, SET_STORED_DEALER_ACCOUNT_ID} from "../action";
import { getStoredDealerIds } from "../api/api.js";

export function fetchStoredDealerAccountDetails(
  parentDealerAccountID,
  userId,
  isSalesPerson
) {
  return (dispatch) => {
    return getStoredDealerIds(
      parentDealerAccountID,
      userId,
      isSalesPerson
    ).then((data) => {
      if(data != undefined) {
        dispatch({type: SET_STORED_DEALER_ACCOUNT_ID, payload: data});
        dispatch({type: DEALER_DATA_AVAILABLE})
      }
    });
  };
}
